import React from 'react'

export const EhcScreening = (props:any) => {
    const {suggested_expert_name1,suggested_expert_name2,suggested_expert_name3,suggest_therapy_type} = props;
    return (
        <div className="col-sm-5 mt-5">
            <h4>EHC Screening Result</h4>
            <table className="table table-striped border-0 mt-4">
                <tbody>
                    <tr>
                        <th scope="row">Suggested Expert Name 1:</th>
                        <td>{suggested_expert_name1}</td>
                    </tr>
                    <tr>
                        <th scope="row">Suggested Expert Name 2:</th>
                        <td>{suggested_expert_name2}</td>
                    </tr>
                    <tr>
                        <th scope="row">Suggested Expert Name 3:</th>
                        <td>{suggested_expert_name3}</td>
                    </tr>
                    <tr>
                        <th scope="row">Suggested Therapy Type:</th>
                        <td>{suggest_therapy_type}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    )
}
